
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transactions/partnerships/layer",
      function () {
        return require("private-next-pages/docs/transactions/partnerships/layer.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transactions/partnerships/layer"])
      });
    }
  